import PropTypes from 'prop-types';
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import './styles.scss';

export default function RangeComponent({ min, max, onChange, ...props }) {
  const handleChange = (evt) => {
    if (onChange) onChange(evt);
  };

  return (
    <Range
      min={min}
      max={max}
      {...props}
      className="Range"
      onChange={handleChange}
    />
  );
}

RangeComponent.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
}
